import React from "react";
import PropTypes from "prop-types";
import { Paper, Typography, LinearProgress, Box } from "@mui/material";

// chart.js has no native 1D-heatmap-as-grid primitive, and the backend already returns a 1D
// {labels, series} array (hour/day-of-week/month) rather than a 2D matrix — a lightweight
// custom color-intensity grid is a better fit here than a Bar chart, and doesn't need a new
// charting dependency.
const HeatmapGrid = ({ title, labels = [], series = [], loading }) => {
  const hasData = labels.length > 0 && series.length > 0;
  const max = Math.max(1, ...series);

  return (
    <Paper sx={{ padding: "1rem" }}>
      <Typography sx={{ fontSize: "16px", fontWeight: 700, marginBottom: "1rem" }}>
        {title}
      </Typography>
      {loading && <LinearProgress />}
      {!loading && !hasData && (
        <Typography sx={{ color: "#6B7280", fontSize: "13px", padding: "2rem 0", textAlign: "center" }}>
          No data available for this range.
        </Typography>
      )}
      {!loading && hasData && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "0.5rem" }}>
          {labels.map((cellLabel, index) => {
            const value = series[index] || 0;
            const intensity = max > 0 ? value / max : 0;

            return (
              <Box key={`${cellLabel}-${index}`} sx={{ width: 64, textAlign: "center" }}>
                <Box
                  sx={{
                    height: 44,
                    borderRadius: "4px",
                    backgroundColor: `rgba(34, 113, 177, ${0.12 + intensity * 0.78})`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: intensity > 0.5 ? "#fff" : "#2c3338",
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  {value}
                </Box>
                <Typography sx={{ fontSize: "10px", marginTop: "2px", color: "#6B7280" }}>
                  {cellLabel}
                </Typography>
              </Box>
            );
          })}
        </Box>
      )}
    </Paper>
  );
};

HeatmapGrid.propTypes = {
  title: PropTypes.string.isRequired,
  labels: PropTypes.array,
  series: PropTypes.array,
  loading: PropTypes.bool,
};

export default HeatmapGrid;
